import React from 'react';
import ReactDOM from 'react-dom';

import history from "./sys/history.js";
import { Router, Route, Switch } from "react-router";

import './index.css';
import './fa/css/font-awesome.css';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import App from './App.jsx';
import Login from './pages/Login.jsx';
import registerServiceWorker from './registerServiceWorker';



ReactDOM.render(
  

<MuiThemeProvider>


    <Router history={history}> 
    
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route path="/" component={App} />      
      </Switch>
    
    </Router> 
 
 </MuiThemeProvider>
 
  , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js